import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import defaultCurrencyApi from '@/features/dashboard/paymentConfig/api/defaultCurrencyApi.ts';
import { defaultCurrencyApiQueryKeys } from '@/features/dashboard/paymentConfig/api/defaultCurrencyApi.queryKeys.ts';
import { DefaultCurrencyDto } from '@/features/dashboard/paymentConfig/types/DefaultCurrencyDto.ts';

const useGetDefaultCurrency = () => {
  return useQuery(getDefaultCurrencyQueryOptions());
};

export const getDefaultCurrencyQueryOptions =
  (): UseQueryOptions<DefaultCurrencyDto> => ({
    queryKey: defaultCurrencyApiQueryKeys.all(),
    queryFn: () => defaultCurrencyApi.get(),
    staleTime: 1000 * 60,
  });

export default useGetDefaultCurrency;
